import { useState } from 'react';
import { DialogContent } from '@mui/material';
import useCurrentTerminal from '@/Hooks/useCurrentTerminal';
import ApplicationSpinner from '@/Infrastructure/Components/Loading/ApplicationSpinner';
import { useFetchItemLocationHistoryQuery } from '@api/Trinium/Endpoints/Consignment/slice';
import ItemLocationHistoryDataGrid from '@components/DataGrid/ItemLocationHistory/Grid';
import ApplicationModal from '@components/Modals/ApplicationModal';
import LegOrderHeader from '@components/Modals/Headers/LegOrderHeader';
import { ViewItemLocationHistoryProps } from './types';

import styles from './ItemLocationHistory.module.css';

export default function Modal({ consignmentId, legId }: ViewItemLocationHistoryProps) {
	const [isOpen, setIsOpen] = useState(true);
	const { number: terminalNumber } = useCurrentTerminal();
	const title = 'View Item Location History';

	const { data: itemLocationHistory, isFetching: itemLocationHistoryListLoading } = useFetchItemLocationHistoryQuery(
		{
			terminalNumber,
			consignmentId
		},
		{
			refetchOnMountOrArgChange: true
		}
	);

	return (
		<ApplicationModal
			isOpen={isOpen}
			onClose={() => {
				setIsOpen(false);
			}}
			title={title}
		>
			<LegOrderHeader
				terminalNumber={terminalNumber}
				legId={legId}
			/>

			<DialogContent className={styles['history-content']}>
				{itemLocationHistoryListLoading ? (
					<ApplicationSpinner />
				) : (
					<>
						<ItemLocationHistoryDataGrid
							rows={itemLocationHistory ?? []}
							consignmentId={consignmentId}
						/>
					</>
				)}
			</DialogContent>
		</ApplicationModal>
	);
}
